// eslint-disable-all
// TODO: Remove this fake response
export const getIDMissionResponse = {
  status: {
    statusCode: '000',
    statusMessage: 'Form Submitted Successfully',
    requestId: 1626579074,
    traceId: '7949683978003920163',
    ipAddress: '104.28.192.82',
  },
  resultData: {
    uniqueRequestId: '1742490821017',
    verificationResultId: 132601777,
    verificationResultDetails: {
      Decision_KeyComponent: {
        DecisionResult: 'Key Component Not Visible',
        DecisionStateCode: '12',
      },
      Decision_DataMatch: {
        DecisionResult: 'OK',
        DecisionStateCode: '00',
      },
      Decision_ImageQuality: {
        DecisionResult: 'OK',
        DecisionStateCode: '00',
      },
      Decision_MRZ: {
        DecisionResult: 'OK',
        DecisionStateCode: '00',
      },
      Decision_SecurityFeature: {
        DecisionResult: 'OK',
        DecisionStateCode: '00',
      },
      Decision_ColorCode: {
        DecisionResult: 'OK',
        DecisionStateCode: '00',
      },
      Decision_Sample: {
        DecisionResult: 'OK',
        DecisionStateCode: '00',
      },
      Decision_FaceDetected: {
        DecisionResult: 'OK',
        DecisionStateCode: '00',
      },
      Decision_AgeValidation: {
        DecisionResult: 'OK',
        DecisionStateCode: '00',
      },
      Decision_FaceMatch: {
        DecisionResult: 'Facial Biometric Match Failed',
        DecisionStateCode: '30',
      },
      Decision_Tamper: {
        DecisionResult: 'Suspected Tampering',
        DecisionStateCode: '70',
      },
      Decision_IDaccepted: {
        DecisionResult: 'OK',
        DecisionStateCode: '00',
      },
      Decision_SuspiciousID: {
        DecisionResult: 'OK',
        DecisionStateCode: '00',
      },
      Decision_Expiration: {
        DecisionResult: 'OK',
        DecisionStateCode: '00',
      },
      Decision_TemplateMatch: {
        DecisionResult: 'OK',
        DecisionStateCode: '00',
      },
      Decision_Liveness: {
        DecisionResult: 'OK',
        DecisionStateCode: '00',
      },
    },
    verificationResult: 'Suspected Tampering',
    verificationResultCode: '70',
    faceVerificationResult: 'Not Verified',
    faceVerificationScore: 0.87,
    faceMask: 'false',
    faceMaskScore: 0.037,
    liveFace: 'true',
    realScore: 1,
    headCovering: 'false',
    headCoveringScore: 0,
    eyeCovering: 'false',
    eyeCoveringScore: 0,
    cellPhone: 'false',
    cellPhoneScore: 0,
  },
  responseCustomerData: {
    extractedIdData: {
      idType: 'VID',
      idCountry: 'MEX',
      idNumber: '161090509',
      idNumber1: 'MAVA540225HDFLVL08',
      idNumber2: '4270056892943',
      idNumber3: 'MLVVVA18402250S000',
      idDateOfBirth: '12/12/1986',
      idDateOfBirthFormatted: '12/12/1986',
      idExpirationDate: '31/12/2027',
      idIssueDate: '01/01/2017',
      idIssueCountry: 'MEX',
      ageOver18: 'Y',
      nationality: 'MEX',
      idNotExpired: 'Y',
      negativeDBMatchFound: 'N',
      mrzErrorMessage: '',
      idNumber1_doc: 'MAVA540225HDFLVL08',
      idNumber3_doc: 'MLVVVA18402250S000',
      idExpirationDate_doc: '28/08/2027',
      idIssueDate_doc: '01/01/2017',
      idFrontRotation: 'Rotate Left',
      idBackRotation: 'Rotate Left',
    },
    extractedPersonalData: {
      name: 'MANUEL GONZALEZ LOPEZ',
      dob: '25/02/1984',
      gender: 'H',
      address: 'XXX',
      addressLine1: 'XXX',
      addressLine2: 'XXX',
      addressLine3: 'XXX',
      parish: '13/05/2027',
      lastName2: 'LOPEZ',
      firstName: 'MANUEL',
      lastName: 'GONZALEZ',
      lastName2_doc: 'LOPEZ',
      firstName_doc: 'MANUEL',
      lastName_doc: 'GONZALEZ',
      name_doc: 'MANUEL GONZALEZ LOPEZ',
    },
    extractedPOAData: [

    ],
    parsedAddress: {
      streetNumber: 'XXX',
      streetName: 'XXX',
      municipality: 'BENITO JUAREZ',
      province: 'CDMX',
      postalCode: '03010',
    },
  },
};
